import { render } from "./AlIceCream.vue?vue&type=template&id=24dc6f78&scoped=true"
import script from "./AlIceCream.vue?vue&type=script&lang=js"
export * from "./AlIceCream.vue?vue&type=script&lang=js"

import "./AlIceCream.vue?vue&type=style&index=0&id=24dc6f78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24dc6f78"]])

export default __exports__